import React from 'react';
import type { WidgetSlot, WidgetProps } from '@yada/types';
import { useWidgets } from './useWidgets';
import { runtime } from '../settings/runtimeRef';
import './WidgetTray.css';

interface WidgetTrayProps {
  slot: WidgetSlot;
}

/**
 * Renders all widgets registered for a given shell slot.
 *
 * Each widget's component receives a persistent AppHostApi created at
 * manifest-registration time, so it survives app switches (e.g. a timer
 * in the navbar keeps ticking while the user navigates to other tools).
 */
export const WidgetTray: React.FC<WidgetTrayProps> = ({ slot }) => {
  const widgets = useWidgets(slot);

  if (widgets.length === 0) return null;

  return (
    <div className="widget-tray" data-slot={slot} role="toolbar" aria-label="Widgets">
      {widgets.map((widget) => {
        const host = runtime.getWidgetHost(widget.id);
        if (!host) return null;
        const Component = widget.component as React.ComponentType<WidgetProps>;
        return (
          <div key={widget.id} className="widget-tray__item">
            <React.Suspense fallback={null}>
              <Component host={host} />
            </React.Suspense>
          </div>
        );
      })}
    </div>
  );
};
